import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { validationMessages } from 'constants/validation'

import { Stack, TextField } from '@mui/material'
import { Section } from 'components/controls/section'

import { SisetuMatchingFormData } from "interface/sisetu/match"

const {
  Required
} = validationMessages

const formSchema = yup.object().shape({
	name: yup.string().required(Required),
	todofuken: yup.string().nullable()
})

type useSisetuSelfMatchingFormProps = {
	formData: SisetuMatchingFormData
	onSubmit: (formData: SisetuMatchingFormData) => void
}
export const useSisetuSelfMatchingForm = ({
	formData,
	onSubmit
}: useSisetuSelfMatchingFormProps) => {
	const form = useForm({
		defaultValues: {
			name: formData.name,
			todofuken: formData.todofuken ?? ''
		},
		mode: 'onChange',
		resolver: yupResolver(formSchema)
	})
	return {
		...form,
    submit: form.handleSubmit(input => onSubmit({
			...formData,
			name: input.name,
			todofuken: input.todofuken
		}))
	}
}

export const SisetuSelfMatchingForm = ({
	control,
	formState: { errors }
}: ReturnType<typeof useSisetuSelfMatchingForm>) => {
	return (
		<Stack direction="column">
			<Section label="施設名" labelProps={{ paddingY: 2 }}>
				<Controller
					control={control}
					name="name"
					render={({ field }) => (
						<>
							<TextField
								{...field}
								variant="outlined"
								size="small"
								error={!!errors.name}
								helperText={errors.name ? errors.name.message : ''}
							/>
						</>
					)}
				/>
			</Section>

			<Section label="都道府県" labelProps={{ py: 2 }}>
				<Controller
					control={control}
					name="todofuken"
					render={({ field }) => (
						<TextField
							{...field}
							variant="outlined"
							fullWidth
							size="small"
							error={!!errors.todofuken}
							helperText={errors.todofuken ? errors.todofuken.message : ''}
						/>
					)}
				/>
			</Section>
		</Stack>
	)
}